// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  z-index: 100;
}

.popup {
  /* width: 70%; */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  z-index: 101; /* Ensure popup is above overlay */
}

.popupcontent {
  /* width: 70%; */
  position: absolute;
  width: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.close {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  background: none;
  border: none;
  cursor: pointer;
}

.close:hover {
  color: #858383;
}
.close_button {
  position: absolute;
  right: -14px;
  top: -20px;
  cursor: pointer;
}
.close_button img {
  width: 17px;
  height: 17px;
}
`, "",{"version":3,"sources":["webpack://./src/Customer/LandingPage/quickactionmodal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kCAA0B;UAA1B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY,EAAE,kCAAkC;AAClD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  backdrop-filter: blur(5px);\r\n  z-index: 100;\r\n}\r\n\r\n.popup {\r\n  /* width: 70%; */\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  z-index: 101; /* Ensure popup is above overlay */\r\n}\r\n\r\n.popupcontent {\r\n  /* width: 70%; */\r\n  position: absolute;\r\n  width: 500px;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n\r\n.close {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #333;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.close:hover {\r\n  color: #858383;\r\n}\r\n.close_button {\r\n  position: absolute;\r\n  right: -14px;\r\n  top: -20px;\r\n  cursor: pointer;\r\n}\r\n.close_button img {\r\n  width: 17px;\r\n  height: 17px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
